import { FC, ReactNode } from 'react'
import { PageActionProps } from 'Shared/components/PageAction'

import PropTypes from 'prop-types'
import { ManageTargetTypes, useManageMenuProps } from './hooks'
import ManageMenuComponent from './ManageMenuComponent'

export interface ManageMenuItem extends Omit<PageActionProps, 'className'> {
  title: string
  className?: 'name' | 'danger'
  disabledReason?: string
}

const ManageMenu: FC<{
  target: any
  type: ManageTargetTypes,
  permission: any,
  title?: ReactNode
}> = ({ target, type, permission = null, title = 'Manage' }) => {
  const [items, components] = useManageMenuProps(type, target, permission)

  return <ManageMenuComponent items={items} components={components} title={title} />
}

ManageMenu.propTypes = {
  target: PropTypes.any,
  type: PropTypes.string,
  permission: PropTypes.any,
  title: PropTypes.element,
}

export default ManageMenu
